import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";

const values = [
  { icon: "ri-heart-3-fill", title: "热爱内容", desc: "我们为每一位热爱妖精漫画的读者，认真筛选值得一看的奇幻作品。" },
  { icon: "ri-leaf-fill", title: "支持正版", desc: "坚持引导读者前往正版平台阅读，守护创作者的每一分心血。" },
  { icon: "ri-flashlight-fill", title: "高效追更", desc: "整合最新话更新情报，让你不错过任何一话的精彩剧情。" },
  { icon: "ri-group-fill", title: "共建社区", desc: "与同好分享世界观解析与追更心得，一起探索妖精的世界。" },
];

const testimonials = [
  { name: "阿澄", role: "奇幻爱好者", text: "这里的分类很清晰，一下就能找到我想追的妖精漫画，更新提醒也很及时。" },
  { name: "小狐狸", role: "异世界读者", text: "编辑精选的质量很高，推荐的好几部异世界作品都成了我的心头好。" },
  { name: "墨羽", role: "妖怪题材党", text: "世界观设定的整理很用心，看之前先了解一下背景，追起来更有代入感。" },
];

const formEndpoint = "https://readdy.ai/api/form/da2kbtqamq5jpe1hrusg";

export default function AboutPage() {
  const [formState, setFormState] = useState<"idle" | "sending" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honeypot = data.get("website_alt");
    if (honeypot && String(honeypot).trim() !== "") {
      setFormState("success");
      form.reset();
      return;
    }

    setFormState("sending");
    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      if (key === "website_alt") return;
      payload.append(key, String(value));
    });

    try {
      const res = await fetch(formEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        /* ignore */
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || responseText || "";

      if (res.ok && parsed?.code === "OK" && !serverMsg.includes("spam")) {
        setFormState("success");
        form.reset();
      } else {
        setFormState("error");
        setFormError(serverMsg || "提交失败，请稍后再试");
      }
    } catch {
      setFormState("error");
      setFormError("网络异常，请稍后再试");
    }
  };

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />

      {/* 面包屑 */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-24 md:pt-28">
        <nav aria-label="面包屑" className="flex flex-wrap items-center gap-2 text-sm text-foreground-600">
          <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
          <i className="ri-arrow-right-s-line text-foreground-400"></i>
          <span className="text-foreground-950">关于我们</span>
        </nav>
      </div>

      {/* 品牌介绍 */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 mt-6 pb-10">
        <div className="grid items-center gap-8 md:grid-cols-2 md:gap-12">
          <div>
            <p className="text-sm font-medium text-primary-500">ABOUT US</p>
            <h1 className="mt-3 font-heading text-2xl font-black md:text-4xl">关于妖精漫画</h1>
            <p className="mt-5 text-sm leading-7 text-foreground-700 md:text-base">
              妖精漫画是一个专注于韩国妖精漫画的内容聚合与追更平台。我们聚合奇幻、魔法、异世界、精灵、妖怪、神话等热门题材，
              以「点开即看世界观设定与最新话更新」为初心，帮助每一位读者快速找到想追的那部妖精漫画。
            </p>
            <p className="mt-4 text-sm leading-7 text-foreground-700">
              在这里，你可以按题材分类浏览作品、查看最新话更新情报、阅读世界观解析，并通过追更入口第一时间抵达正版阅读页面。
            </p>
          </div>
          <div className="relative overflow-hidden rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=fantasy%20fairy%20world%20with%20floating%20spirits%20books%20and%20ancient%20elven%20architecture%2C%20deep%20emerald%20and%20amber%20gold%20palette%2C%20cinematic%20storybook%20atmosphere&width=900&height=640&seq=about-fantasy&orientation=landscape"
              alt="妖精漫画品牌愿景场景"
              title="妖精漫画关于我们"
              className="h-72 w-full object-cover md:h-80"
            />
          </div>
        </div>
      </section>

      {/* 定位与理念 */}
      <section className="border-y border-background-200/60 bg-background-100/50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
          <div className="text-center">
            <p className="text-sm font-medium text-accent-600">OUR VALUES</p>
            <h2 className="mt-2 font-heading text-2xl font-bold md:text-3xl">我们的理念与内容原则</h2>
            <p className="mx-auto mt-3 max-w-2xl text-sm leading-6 text-foreground-600">
              我们相信，一部好的妖精漫画值得被更多人看见，也相信支持正版才能让好故事走得更远。
            </p>
          </div>
          <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v) => (
              <div
                key={v.title}
                className="rounded-lg border border-background-200/70 bg-background-50 p-6 transition-transform hover:-translate-y-1"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className={`${v.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 用户口碑 */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="text-center">
          <p className="text-sm font-medium text-primary-500">TESTIMONIALS</p>
          <h2 className="mt-2 font-heading text-2xl font-bold md:text-3xl">读者口碑</h2>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="rounded-lg border border-background-200/70 bg-background-100/60 p-6">
              <div className="flex gap-1 text-primary-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-3 text-sm leading-6 text-foreground-700">「{t.text}」</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 font-heading font-bold text-secondary-900">
                  {t.name[0]}
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-600">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* 联系方式 */}
      <section id="contact" className="border-t border-background-200/60 bg-background-100/50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
          <div className="grid gap-10 lg:grid-cols-2 lg:gap-14">
            <div>
              <p className="text-sm font-medium text-accent-600">CONTACT</p>
              <h2 className="mt-2 font-heading text-2xl font-bold md:text-3xl">联系我们</h2>
              <p className="mt-4 text-sm leading-7 text-foreground-700">
                无论是作品投稿推荐、内容建议，还是合作洽谈，都欢迎随时联系我们。我们会在收到消息后尽快回复。
              </p>
              <ul className="mt-7 space-y-4 text-sm">
                <li className="flex items-center gap-3 text-foreground-700">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-mail-line"></i>
                  </span>
                  <span>contact@yaojing-manga.site</span>
                </li>
                <li className="flex items-center gap-3 text-foreground-700">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-message-3-line"></i>
                  </span>
                  <span>官方粉丝群：欢迎通过邮件申请加入</span>
                </li>
              </ul>
            </div>

            <form onSubmit={handleSubmit} className="rounded-lg border border-background-200/70 bg-background-50 p-6 md:p-8" data-readdy-form>
              <div className="space-y-4">
                <div>
                  <label htmlFor="name" className="mb-1.5 block text-sm font-medium text-foreground-800">
                    你的称呼
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    placeholder="请输入称呼"
                    className="w-full rounded-md border border-background-200 bg-background-100 px-4 py-2.5 text-sm text-foreground-950 placeholder:text-foreground-400 focus:border-primary-300 focus:outline-none"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="mb-1.5 block text-sm font-medium text-foreground-800">
                    邮箱
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    placeholder="name@example.com"
                    className="w-full rounded-md border border-background-200 bg-background-100 px-4 py-2.5 text-sm text-foreground-950 placeholder:text-foreground-400 focus:border-primary-300 focus:outline-none"
                  />
                </div>
                <div>
                  <label htmlFor="subject" className="mb-1.5 block text-sm font-medium text-foreground-800">
                    主题
                  </label>
                  <input
                    id="subject"
                    name="subject"
                    type="text"
                    required
                    placeholder="例如：作品投稿 / 内容建议"
                    className="w-full rounded-md border border-background-200 bg-background-100 px-4 py-2.5 text-sm text-foreground-950 placeholder:text-foreground-400 focus:border-primary-300 focus:outline-none"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="mb-1.5 block text-sm font-medium text-foreground-800">
                    留言内容
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    placeholder="请详细描述你的需求或想法（最多500字）"
                    className="w-full resize-none rounded-md border border-background-200 bg-background-100 px-4 py-2.5 text-sm text-foreground-950 placeholder:text-foreground-400 focus:border-primary-300 focus:outline-none"
                  ></textarea>
                </div>

                {/* 反垃圾诱捕字段 */}
                <div className="form-honeypot-field" aria-hidden="true">
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    readOnly
                  />
                </div>

                {formState === "error" && (
                  <p className="rounded-md bg-accent-100 px-4 py-3 text-sm text-accent-900" role="alert">
                    <i className="ri-error-warning-line mr-1"></i>
                    {formError}
                  </p>
                )}
                {formState === "success" && (
                  <p className="rounded-md bg-primary-100 px-4 py-3 text-sm text-primary-700" role="status">
                    <i className="ri-checkbox-circle-line mr-1"></i>
                    已收到你的消息，我们会尽快与你联系！
                  </p>
                )}

                <button
                  type="submit"
                  disabled={formState === "sending"}
                  className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
                >
                  {formState === "sending" ? "发送中..." : "发送留言"}
                  <i className="ri-send-plane-fill"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </div>
  );
}